import React from "react";

export default function Report() {
  return (
    <div>
      <p>Report</p>
    </div>
  );
}
